import { Action } from 'redux'
import { isType } from 'ts-action'
import { IGigDaysReducer } from 'models/GigDay'
import { GetGigDays, GetGigDaysErrors, GigDaysFetching } from './actions'

const initialState: IGigDaysReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const gigDaysReducer = (
  state = initialState,
  action: Action,
): IGigDaysReducer => {
  if (isType(action, GetGigDays)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }

  if (isType(action, GetGigDaysErrors)) {
    const { payload } = action
    return {
      ...state,
      error: {
        code: payload.code,
        message: payload.message,
      },
    }
  }

  if (isType(action, GigDaysFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
